<template>
	<!-- la URL que envia el email debe ser http://localhost:8080/clients/welcome?request=REQUESTID&token=TOKENREQUEST&user=client -->
	<CContainer class="d-flex content-center bg-white">
		<div class="">
			<br />
			<br />
			<CRow>
				<CCol sm="12" class="borderInfoFriend">
					<h3>¡No queremos que esto te pase a ti!</h3>
				</CCol>
			</CRow>
			<br />
			<CRow>
				<CCol sm="12">
					<!-- <p class="h5">Si tu aviso no está</b></p> -->
					<h5>
						Si tu aviso no está pubiclado en <b>Infoguia</b> es muy
						probable que esto ocurra:
					</h5>
				</CCol>
			</CRow>
			<br /><br />
			<CRow class="content-center">
				<CCol sm="5" class="">
					<img
						class="img-fluid"
						:src="this.imgInfoBuddySad"
						alt="infoFriend2"
					/>
				</CCol>
				<CCol sm="7" class="content-left">
					<h5>
						<!-- <CIcon :height="20" name="cil-check" /> Mayor alcance de clientes -->
						<span style="color:#e55353;font-size: 30px;"
							><i class="fas fa-sad-cry" aria-hidden="true"></i
						></span>
						Menor exposición en la búsqueda de su empresa
					</h5>
					<br />
					<h5>
						<!-- <CIcon :height="20" name="cil-check" /> Tráfico en tus redes sociales -->
						<span style="color:#e55353;font-size: 30px;"
							><i class="fas fa-sad-cry" aria-hidden="true"></i
						></span>
						Disminución de tráfico en las redes sociales
					</h5>
					<br />
					<h5>
						<!-- <CIcon :height="20" name="cil-check" /> Posicionamientoen la búsqueda de tu web -->
						<span style="color:#e55353;font-size: 30px;"
							><i class="fas fa-sad-cry" aria-hidden="true"></i
						></span>
						Falta de visibilidad y credibilidad
					</h5>
					<br />
					<h5>
						<!-- <CIcon :height="20" name="cil-check" /> Aumento de visibilidad en la web de tu marca -->
						<span style="color:#e55353;font-size: 30px;"
							><i class="fas fa-sad-cry" aria-hidden="true"></i
						></span>
						Menos ventas
					</h5>
					<br />
					<h5>
						<!-- <CIcon :height="20" name="cil-check" /> Atracción y credibilidad -->
						<span style="color:#e55353;font-size: 30px;"
							><i class="fas fa-sad-cry" aria-hidden="true"></i
						></span>
						Ningún tipo de posicionamiento en la web
					</h5>
					<br />
					<h5>
						<!-- <CIcon :height="20" name="cil-check" /> Atracción y credibilidad -->
						<span style="color:#e55353;font-size: 30px;"
							><i class="fas fa-sad-cry" aria-hidden="true"></i
						></span>
						Falta de información sobre su empresa en la web
					</h5>
					<br />
				</CCol>
			</CRow>
			<br /><br />
			<CRow v-if="!this.noUpdate" class="content-center">
				<CCol sm="12">
					<b-button
						@click="updateDataClient"
						variant="success"
						size="lg"
						class="mr-1"
						style="margin: 2%;"
					>
						Mejor actualizo mis datos
					</b-button>
					<b-button
						@click="noUpdate = true"
						variant="warning"
						size="lg"
						class="mr-1"
						style="margin: 2%;"
						>No quiero actualizar mis datos
					</b-button>
				</CCol>
			</CRow>
			<CRow v-else class="content-center" style="text-align:left;">
				<CCol sm="10">
					<h5>
						Por favor indique a continuación por que no desea
						actualiza sus datos.
					</h5>
					<br />
					<div role="group" class="form-group">
						<label for="urb">Razón para no actualizar</label>
						<multiselect
							v-if="reasonsNotUpdate != null"
							v-model="selectedReasonId"
							:allow-empty="false"
							track-by="idReasonsNotPost"
							label="name"
							:options="reasonsNotUpdate"
							:searchable="true"
							:close-on-select="true"
							:preselect-first="true"
							:show-labels="false"
							placeholder="Seleccione"
						>
							<span slot="noResult"
								>Oops! No se encontró la opción deseada</span
							>
						</multiselect>
					</div>
				</CCol>
				<CCol sm="10">
					<ValidationProvider
						name="Comentarios"
						rules="required|min:10"
						v-slot="{ valid, errors, touched }"
					>
						<CTextarea
							v-model="commentNoUpdate"
							id="description"
							label="Comentarios"
							vertical
							rows="10"
							description="Por favor ingrese un comentario"
							:isValid="
								touched && !valid
									? valid
									: touched && valid
									? valid
									: null
							"
						>
							<template #invalid-feedback>
								<span class="invalid-feedback">{{
									errors[0]
								}}</span>
							</template>
						</CTextarea>
						<div class="content-center" v-if="valid">
							<b-button
								@click="saveNoUpdate"
								variant="warning"
								size="md"
								class="mr-1"
								style="margin: 2%;"
								>No actualizar mis datos
							</b-button>
						</div>
					</ValidationProvider>
				</CCol>
			</CRow>
			<br /><br />
			<CRow class="">
				<CCol sm="12" class="">
					<img
						class="img-fluid"
						:src="this.imgBussinessChange"
						alt="imgInfoBuddyHappy"
					/>
				</CCol>
			</CRow>
			<br /><br />
			<!-- modales -->
			<div>
				<!-- modal de soicitud enviada con exito -->
				<CModal
					:show.sync="modalSuccessSend"
					:close-on-backdrop="false"
					:centered="true"
					title="No actualizar mis datos"
					size="lg"
					color="info"
				>
					Su solicitud de no actualizar sus datos fue enviada con
					éxito. <br /><br />
					Al cerrar este aviso será redireccionado al site de
					<b>Infoguia</b>.
					<template #header>
						<h6 class="modal-title">No actualizar mis datos</h6>
						<CButtonClose
							@click="openInfoguia"
							class="text-white"
						/>
					</template>
					<template #footer>
						<b-button
							@click="openInfoguia"
							variant="outline-info"
							size="lg"
							class="mr-1"
							>Cerrar
						</b-button>
					</template>
				</CModal>
				<!-- modal indicando que el cliente solicito no actualizar sus datos -->
				<CModal
					:show.sync="modalAlreadyNotUpdate"
					:close-on-backdrop="false"
					:centered="true"
					title="No actualizar mis datos"
					size="sm"
					color="warning"
				>
					{{ errorMessage }}
					<template #header>
						<h6 class="modal-title">Ya existe una solicitud</h6>
						<CButtonClose
							@click="modalAlreadyNotUpdate = false"
							class="text-white"
						/>
					</template>
					<template #footer>
						<b-button
							@click="modalAlreadyNotUpdate = false"
							variant="outline-info"
							size="lg"
							class="mr-1"
							>Cerrar
						</b-button>
					</template>
				</CModal>
			</div>
		</div>
	</CContainer>
</template>
<script>
	import '../../validations/validationsForm.js';
	import saveToAPI from '../../functions/saveForm';
	export default {
		/**Componente usado cuando el cliente indica que no desea actualizar sus datos */
		name: 'noUpdate',
		title: 'No actualizar mis datos | Infoguia',
		beforeCreate: function() {
			sessionStorage.setItem('accessToken', '');
			sessionStorage.setItem('idRequest', this.$route.query.re);
			sessionStorage.setItem('userType', this.$route.query.u);
		},
		created() {
			let loader = this.$loading.show();
			this.$http
				.get('/api/v1/reasonsnotpost?sort_by=name')
				.then((dataReason) => {
					console.log(dataReason);
					this.reasonsNotUpdate = dataReason.data.data;
				})
				.catch(function(error) {
					// handle error
					console.log(error);
				})
				.finally(() => {
					loader.hide();
				});
		},
		data() {
			return {
				imgInfoBuddySad: process.env.VUE_APP_NOUPDATE_INFOBUDDYSAD,
				imgBussinessChange:
					process.env.VUE_APP_NOUPDATE_BUSSINESSCHANGE,
				noUpdate: false,
				reasonsNotUpdate: null,
				selectedReasonId: null,
				commentNoUpdate: '',
				modalSuccessSend: false,
				modalAlreadyNotUpdate: false,
				errorMessage: '',
			};
		},
		mounted() {},
		methods: {
			saveNoUpdate() {
				let dataForNotUpdate = {
					idreasonsnotpost: this.selectedReasonId.idReasonsNotPost,
					description: this.commentNoUpdate,
				};
				let loader = this.$loading.show();
				saveToAPI
					.saveNoUpdate(dataForNotUpdate, this.$route.query.re)
					.then((response) => {
						console.log(response);
						this.modalSuccessSend = true;
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
			openInfoguia() {
				window.location.href = 'https://infoguia.com/';
			},
			updateDataClient() {
				let loader = this.$loading.show();
				let idRequest = this.$route.query.re;
				let tokenForRequest = this.$route.query.to;
				this.$http
					.get(
						'/api/v1/requestsrows/' +
							idRequest +
							'/verify/' +
							tokenForRequest
					)
					.then((dataClient) => {
						let token = dataClient.data.data.token;
						sessionStorage.setItem('accessToken', token);
						this.$router.push({
							name: 'FormClient',
						});
					})
					.catch((errors) => {
						console.log(errors.response);
						let errorCode = errors.response.data.code;
						switch (errorCode) {
							case 404:
								this.$router.push({
									name: 'Page404',
								});
								break;
							case 409:
								this.modalAlreadyNotUpdate = true;
								this.errorMessage = errors.response.data.error;
								console.log(this.modalAlreadyNotUpdate);
								break;
						}
					})
					.finally(() => {
						loader.hide();
					});
			},
		},
	};
</script>
